<template>
  <table class="print-table">
    <thead>
      <tr>
        <th>收款日期</th>
        <th>收款账户</th>
        <th>收款类型</th>
        <th>收款金额(元)</th>
        <th>收入科目</th>
        <th>备注</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in selfData" :key="index">
        <td>{{ item.create_time ? item.create_time.slice(0, 10) : '' }}</td>
        <td>{{ item.bank_name }}</td>
        <td>{{ item.collection_type }}</td>
        <td>{{ item.amount_received }}</td>
        <td>{{ item.ke_mu }}</td>
        <td>{{ item.remark }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfData: []
    }
  },
  mounted() {
    this.selfData = this.$util.deepCopy(this.data)
  }
}
</script>

<style lang="less" scoped>
.print-table {
  margin-top: 5px;
  width: 100%;
  border-collapse: collapse;
  border-left: 1px solid #000;
  border-top: 1px solid #000;
  text-align: center;
}
.print-table th,
.print-table td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 2px;
  overflow-wrap: anywhere;
}
.print-table th {
  font-weight: normal;
  background: #e0e5eb;
}
</style>
